import { timer } from 'rxjs';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { SharedService } from 'src/app/services/shared.service';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.css']
})
export class UsuariosComponent {

  users: any[] = [];
  searchTerm: string = '';
  originalUsers: any[] = [];
  loading: boolean = true;
  mensajeUsuarios: string = '';

  constructor(
    private router: Router,
    private sharedService: SharedService,
    private requestsService: CatalogsService,
    private navigationService: NavigationService) { }

  ngOnInit() {
    this.obtenerToken();
  }

  obtenerToken() {
    this.navigationService.disableNavigation();
    const token = String(localStorage.getItem('token1'))
    timer(1).subscribe(() => {
      this.requestsService.getAllUser(token).subscribe(
        (data: any) => {
          data.length === 0 ? this.mensajeError('No se tienen usuarios que mostrar.') : this.users = data;
          this.originalUsers = data;
          this.loading = false;
        });
    });
  }

  search() {
    if (this.searchTerm) {
      this.buscador();
    } else {
      this.users = this.originalUsers;
    }
  }


  buscador() {
    this.users = this.originalUsers.filter(user => {
      const nombre = user.Usr_Nombre ? user.Usr_Nombre.toLowerCase() : '';
      const apellidoPaterno = user.Usr_Apellido_Paterno ? user.Usr_Apellido_Paterno.toLowerCase() : '';
      const apellidoMaterno = user.Usr_Apellido_Materno ? user.Usr_Apellido_Materno.toLowerCase() : '';
      const rolNombre = user.rol_nombre ? user.rol_nombre.toLowerCase() : '';

      return (
        nombre.includes(this.searchTerm.toLowerCase()) ||
        apellidoPaterno.includes(this.searchTerm.toLowerCase()) ||
        apellidoMaterno.includes(this.searchTerm.toLowerCase()) ||
        rolNombre.includes(this.searchTerm.toLowerCase())
      );
    });

    this.users.length === 0 && this.mensajeError(`Con los criterios ${this.searchTerm}, no encontramos ninguna coincidencia.`);
  }

  mensajeError(mensaje: string) {
    this.mensajeUsuarios = mensaje;
  }

  editar(op: any, user: any) {
    const opE = op.toString()
    this.sharedService.setData(opE);
    this.sharedService.setDataArray(user);
    this.router.navigate(['/usuariosD', opE]);
  }

  agregar(op: any) {
    const opE = op.toString()
    this.sharedService.setData(opE);
    this.router.navigate(['/usuariosD', opE]);
  }

}
